module.exports = __webpack_public_path__ + "img/500.27e16260.png";